var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8176 6.26927H13.8212C13.8398 6.47394 13.849 6.68082 13.849 6.88989C13.8494 7.51988 13.7628 8.14691 13.5918 8.75325L12.4959 8.44351C13.2037 5.94019 12.1214 3.27588 9.86837 1.9753C7.61535 0.674716 4.7669 1.06995 2.9531 2.93482C1.1393 4.79969 0.823297 7.65802 2.18592 9.87406C3.54855 12.0901 6.24188 13.098 8.72458 12.321V13.4976C5.93732 14.2294 2.98977 13.1415 1.34628 10.7744C-0.297213 8.40724 -0.286346 5.26536 1.37348 2.90964C3.03331 0.553913 5.98831 -0.513548 8.77044 0.237566C11.5526 0.98868 13.5689 3.39827 13.8176 6.26927ZM3.60013 6.88988C3.60013 8.77665 5.12965 10.3062 7.01642 10.3062C8.90233 10.3041 10.4306 8.77579 10.4327 6.88988C10.4327 5.00312 8.90318 3.47359 7.01642 3.47359C5.12965 3.47359 3.60013 5.00312 3.60013 6.88988ZM4.73892 6.88987C4.73892 5.63203 5.75861 4.61234 7.01645 4.61234C8.27371 4.61376 9.29256 5.63261 9.29398 6.88987C9.29398 8.14771 8.27429 9.1674 7.01645 9.1674C5.75861 9.1674 4.73892 8.14771 4.73892 6.88987ZM7.01642 8.02864C7.64534 8.02864 8.15518 7.5188 8.15518 6.88988C8.15518 6.26096 7.64534 5.75112 7.01642 5.75112C6.3875 5.75112 5.87766 6.26096 5.87766 6.88988C5.87766 7.5188 6.3875 8.02864 7.01642 8.02864ZM16.1265 13.1531L11.0021 16V10.3062L16.1265 13.1531Z",
    fill: "#115E67"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.f0e07b068dec3587c45265d835d375dc.svg";
export { ForwardRef as ReactComponent };